import { cn } from '@/lib/utils';

/**
 * Hors plein écran, la boîte est dimensionnée par sa hauteur et porte le 16:9 (l'overscan
 * anti-liseré tombe ainsi sur le bord réel de l'image). En plein écran elle perd son ratio pour
 * remplir l'écran : sans largeur explicite, elle retombe à 0 px dans son conteneur flex.
 */
export function evergreenVideoBoxClassName(isFullscreen: boolean): string {
  return cn(
    'relative h-full aspect-video overflow-hidden rounded-none lg:rounded-2xl',
    isFullscreen && 'w-full h-full aspect-auto rounded-none lg:rounded-none',
  );
}

/** Calque des contrôles, calé sur la même boîte que la vidéo. */
export function evergreenControlsBoxClassName(isFullscreen: boolean): string {
  return cn('relative h-full aspect-video', isFullscreen && 'w-full h-full aspect-auto');
}
